import { useStaticQuery, graphql } from "gatsby"

const QUERY = graphql`
  query {
    images: allFile(
      filter: { absolutePath: { regex: "//head_team/" } }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          extension
          relativePath
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 50
              breakpoints: [320, 500]
            )
          }
        }
      }
    }
  }
`

const GetHeadteam = () => {
  const { images } = useStaticQuery(QUERY)
  return images.edges || []
}

const headteam = () => {
  const data = GetHeadteam()
  return data
}

export default headteam
